<template>
    <div v-observe-visibility="visibilityChanged">

        <!--Confirming Position - Loading-->
        <v-dialog class="loading-dialog"
                  v-model="confirmPositionLoading"
                  persistent
                  overlay
                  max-width="450px">
            <v-card>
                <v-layout row pt-4 pb-4 pr-4 pl-4>
                    <v-flex grow>
                        <v-card-title class="headline">Confirming Position...</v-card-title>
                    </v-flex>
                    <v-flex shrink>
                        <v-progress-circular
                                :size="70"
                                :width="7"
                                color="primary"
                                indeterminate
                        ></v-progress-circular>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-dialog>

        <!--Saving Position - Loading-->
        <v-dialog class="loading-dialog"
                  v-model="savingInvoicePosition"
                  persistent
                  overlay
                  max-width="450px">
            <v-card>
                <v-layout row pt-4 pb-4 pr-4 pl-4>
                    <v-flex grow>
                        <v-card-title class="headline">Saving Position...</v-card-title>
                    </v-flex>
                    <v-flex shrink>
                        <v-progress-circular
                                :size="70"
                                :width="7"
                                color="primary"
                                indeterminate
                        ></v-progress-circular>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-dialog>

        <!--Add/Edit Position - Dialog-->
        <v-dialog persistent overlay v-model="addDialog" max-width="800px">
            <v-card>

                <v-card-title>
                    <span v-if="selectedPosition.id !== 0" class="headline">Edit Position</span>
                    <span v-else class="headline">Add Position</span>
                </v-card-title>

                <v-card-text>
                    <v-container grid-list-md>
                        <v-layout wrap>
                            <v-flex sm12 md8 pl-4 pa-2>
                                <v-text-field
                                        label="Product Reference"
                                        :value="selectedPosition.product.reference"
                                        readonly
                                ></v-text-field>
                            </v-flex>

                            <v-flex sm12 md4 pl-4 pa-2>
                                <v-text-field
                                        label="Manufacturer"
                                        :value="selectedPosition.product.manufacturer.name"
                                        readonly
                                ></v-text-field>
                            </v-flex>

                            <v-flex sm12 md6 pl-4 pa-2>
                                <v-text-field
                                        label="Quantity"
                                        v-model="selectedPosition.quantity"
                                        type="number"
                                        min="1"

                                ></v-text-field>
                            </v-flex>

                            <v-flex sm12 md6 pl-4 pa-2>
                                <v-autocomplete
                                        clearable
                                        :items="getUnits"
                                        label="Unit"
                                        v-model="selectedPosition.units_id"
                                        item-value="id"
                                        item-text="name"
                                ></v-autocomplete>
                            </v-flex>

                            <v-flex sm12 md12 pl-4 pa-2>
                                <v-autocomplete
                                        clearable
                                        :items="getVats"
                                        label="VAT/Tax"
                                        v-model="selectedPosition.vats_id"
                                        item-value="id"
                                        item-text="name"
                                ></v-autocomplete>
                            </v-flex>

                            <v-flex xs12 md6 pl-4 pr-4>
                                <v-autocomplete :items="countries"
                                                label="Origin"
                                                v-model="selectedPosition.origin"
                                                required
                                ></v-autocomplete>
                            </v-flex>

                            <v-flex xs12 md6 pl-4 pr-4>

                                <v-autocomplete
                                        clearable
                                        v-model="selectedPosition.manufacturers_branch_offices_id"
                                        :items="getManufacturerBranchOffices"
                                        label="Manufacturer Address / Origin"
                                        item-value="id"
                                        :filter="customBranchOfficeFilter"
                                        :loading="loading"
                                >
                                    <template slot="item" slot-scope="data">
                                        <v-list-tile-content>
                                            <v-list-tile-title>{{data.item.name}}
                                            </v-list-tile-title>
                                            <v-list-tile-sub-title>{{data.item.city}} - {{data.item.zipcode}} -
                                                {{data.item.country}}
                                            </v-list-tile-sub-title>
                                        </v-list-tile-content>
                                    </template>

                                    <template slot="selection" slot-scope="data">
                                        <v-list-tile-content>
                                            <v-list-tile-title>{{data.item.name}}
                                            </v-list-tile-title>
                                            <v-list-tile-sub-title>{{data.item.city}} - {{data.item.zipcode}} -
                                                {{data.item.country}}
                                            </v-list-tile-sub-title>
                                        </v-list-tile-content>
                                    </template>

                                    <template slot="no-data">
                                        <v-layout wrap>
                                            <v-flex xs12 pl-4 pr-4>
                                                <v-btn @click.native="" block
                                                       small flat color="secondary">Create
                                                    New Branch Office
                                                    <v-icon>add</v-icon>
                                                </v-btn>
                                            </v-flex>
                                        </v-layout>
                                    </template>
                                </v-autocomplete>
                            </v-flex>

                            <v-flex xs12 md12 pl-4 pr-4>
                                <v-textarea
                                        auto-grow
                                        rows="4"
                                        label="Remark"
                                        v-model="selectedPosition.remark"
                                ></v-textarea>
                            </v-flex>

                        </v-layout>
                    </v-container>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary darken-1" flat @click.native="closeAddEditPositionDialog">Cancel</v-btn>
                    <v-btn color="primary darken-1" flat @click.native="savePosition()">
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!--DELETE - Dialog-->
        <v-dialog
                persistent
                v-model="deleteDialog" max-width="400px">
            <v-card>
                <v-card-title>
                    <span class="headline">Delete Position</span>
                </v-card-title>

                <v-card-text>
                    <v-form ref="form" v-model="deleteFormValidation" lazy-validation>
                        <v-checkbox
                                :rules="[v => !!v || 'You have to check this to continue!']"
                                required
                                v-model="deleteChecked" color="primary"
                                label="Do you really want to delete this position?"></v-checkbox>
                    </v-form>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary darken-1" flat @click.native="cancelDeleteDialog()">CANCEL</v-btn>
                    <v-btn color="primary darken-1" flat @click.native="deletePosition()">
                        OK
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!--CONFIRM - Dialog-->
        <v-dialog
                persistent
                v-model="confirmDialogState" max-width="400px">
            <v-card>
                <v-card-title>
                    <span class="headline">Confirm Position</span>
                </v-card-title>

                <v-card-text>
                    Do you really want to confirm this position?
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary darken-1" flat @click.native="cancelConfirmDialog()">CANCEL</v-btn>
                    <v-btn color="primary darken-1" flat @click.native="confirmPosition()">
                        OK
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-layout id="table-container" row>
            <v-flex xs12 pr-4 pt-4 pl-4>
                <v-card>
                    <v-card-title>
                        Invoice Positions
                        <v-spacer></v-spacer>
                        <v-text-field
                                v-model="search"
                                append-icon="search"
                                label="Search"
                                single-line
                                hide-details
                                clearable
                        ></v-text-field>
                    </v-card-title>

                    <v-data-table
                            :headers="headers"
                            :items="getItems"
                            :pagination.sync="pagination"
                            :total-items=total
                            class="elevation-0 offer-table"
                            :loading="loadingPositions"
                            :rows-per-page-items="rowsPageItems"
                    >

                        <template slot="headerCell" slot-scope="props">
                            <v-tooltip bottom>
                                        <span slot="activator">
                                          {{ props.header.text }}
                                        </span>
                                <span>
                                          {{ props.header.text }}
                                        </span>
                            </v-tooltip>
                        </template>
                        <template slot="items" slot-scope="props">
                            <tr @dblclick="openSelectedInvoicePosition(props.item.id)">
                                <td>{{ props.item.id }}</td>
                                <td class="text-xs-left">{{
                                    props.item.product.reference }}
                                </td>
                                <td class="text-xs-left">{{
                                    props.item.product.manufacturer.name }}
                                </td>
                                <td class="text-xs-right">{{positionReceivedQuantity(props.item)}} / {{
                                    props.item.quantity }}
                                </td>
                                <td class="text-xs-right">{{pickedAmount(props.item.purchase_order_position)}}
                                </td>
                                <td class="text-xs-left">{{props.item.unit.code }}</td>
                                <td class="text-xs-right">
                                  {{props.item.vat.name}}
                                </td>
                                <td class="text-xs-right">{{props.item.unit_price | toMoney}}
                                    {{props.item.invoice.currency.name}}
                                </td>
                                <td class="text-xs-right">{{props.item.total_amount | toMoney}}
                                    {{props.item.invoice.currency.name}}
                                </td>
                                <td class="text-xs-left">{{ props.item.invoices_positions_status.name }}</td>

                                <td class="text-xs-right">

                                    <v-icon color="primary"
                                            class="ma-1"
                                            @click="openConfirmDialog(props.item.id)"
                                            :disabled="props.item.invoices_positions_status_id === 2"
                                    >
                                      fa-solid fa-file
                                    </v-icon>

                                    <v-icon color="red"
                                            class="ma-1"
                                            @click="deletePositionDialog(props.item)"
                                    >
                                        delete
                                    </v-icon>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>

                </v-card>
            </v-flex>

        </v-layout>

        <v-layout row wrap ma-4>
            <v-flex grow>
            </v-flex>
            <v-flex shrink>
                <v-btn shrink :loading="startPickingLoading" class="secondary white--text"
                       @click.native="startPicking()">
                    START PICKING
                </v-btn>
            </v-flex>
        </v-layout>

    </div>
</template>

<script>
import {
  Settings,
  VatSettings,
  Invoice,
  InvoicePosition,
  ManufacturerBranchOfficeSettings
} from '../../../store/namespace-helper'
import {numberFormatFilters} from '../../../mixins/numberFormatFilters'

import _ from 'lodash'

export default {
  mixins: [numberFormatFilters],
  name: 'invoice-positions',
  components: {},
  data () {
    return {
      isVisible: false,
      hide: true,
      activeTab: 0,
      countries: this.$store.getters.countries,
      headers: [
        {text: 'Position-ID', value: 'id'},
        {text: 'Reference', value: 'reference'},
        {text: 'Manufacturer', value: 'manufacturers_id'},
        {text: 'Received/Quantity', value: 'quantity', align: 'right'},
        {text: 'Already Picked', value: 'picked_amount', align: 'right'},
        {text: 'Unit', value: 'unit_id', sortable: false},
        {text: 'Vat', value: 'vat', align: 'right', sortable: false},
        {text: 'Unit Sales Price', value: 'unit_sales_price', align: 'right'},
        {text: 'Total Sales Price', value: 'total_sales_price', align: 'right'},
        {text: 'Status', value: 'inquiries_position_status_id'},
        {text: 'Action', value: 'action', sortable: false, align: 'right'}
      ],
      pagination: {},
      search: '',
      total: 0,
      rowsPageItems: [{'text': 'All', 'value': -1}],
      creatingInvoice: false,
      positionData: null,
      deleteDialog: false,
      deleteChecked: false,
      deleteFormValidation: false,
      loadingPositions: false,
      addDialog: false,
      confirmDialogState: false,
      startPickingLoading: false,
      confirmPositionLoading: false,
      savingInvoicePosition: false
    }
  },
  mounted () {

  },
  methods: {
    visibilityChanged (isVisible, entry) {
      if (this.isVisible !== isVisible) {
        this.isVisible = isVisible
        if (isVisible) {
          console.log('tab order positions visible, load data')
          this.loadItems()
          this.loadUnits()
          this.loadVats()
        } else {

        }
      }
    },
    customBranchOfficeFilter (item, queryText, itemText) {
      const isMatch = (test, query) => {
        return test.toString().toLowerCase().indexOf(query.toString().toLowerCase()) > -1
      }
      const query = queryText || ''
      const displayText = item.city + ' ' + item.zipcode + ' ' + item.country
      const rc = isMatch(item.name, query) ||
                    isMatch(item.city, query) ||
                    isMatch(item.country, query) ||
                    isMatch(item.zipcode, query) ||
                    isMatch(displayText, query)
      console.log(`filter: ${JSON.stringify(item)}, '${query}', ${JSON.stringify(itemText)} => ${rc}`)
      return rc
    },
    loadItems: function () {
      const {sortBy, descending, page, rowsPerPage} = this.pagination
      const query = {
        id: this.selectedItem.id,
        sortBy: sortBy || 'id',
        descending: descending ? 'desc' : 'asc',
        page: page || 1,
        limit: rowsPerPage !== -1 ? rowsPerPage : 0,
        search: this.search ? this.search : ''
      }
      if (this.selectedItem.id !== 0) {
        this.loadingPositions = true
        this.$store.dispatch(InvoicePosition.actions.loadInvoicePositionForInvoice, query).then(response => {
          this.loadingPositions = false
        }).catch(err => {
          console.log(JSON.stringify(err))
          this.loadingPositions = false
        })
      }
    },
    startPicking () {
      this.startPickingLoading = true
      this.$store.dispatch(Invoice.actions.startPicking, this.selectedItem).then(response => {
        this.startPickingLoading = false
        this.$store.dispatch(Invoice.actions.reloadSelectedInvoice, this.selectedItem.id)
      }).catch(reason => {
        this.startPickingLoading = false
      })
    },
    confirmPosition () {
      this.confirmPositionLoading = true
      this.confirmDialogState = false
      this.$store.dispatch(InvoicePosition.actions.confirmInvoicePosition, this.selectedPosition).then(response => {
        this.confirmPositionLoading = false
        this.loadItems()
      }).catch(reason => {
        this.confirmPositionLoading = false
      })
    },
    savePosition () {
      this.savingInvoicePosition = true
      this.addDialog = false
      let invoicePosition = {
        id: this.selectedPosition.id,
        units_id: this.selectedPosition.units_id,
        vats_id: this.selectedPosition.vats_id,
        quantity: this.selectedPosition.quantity,
        manufacturers_branch_offices_id: this.selectedPosition.manufacturers_branch_offices_id,
        origin: this.selectedPosition.origin,
        remark: this.selectedPosition.remark
      }
      this.$store.dispatch(InvoicePosition.actions.saveInvoicePosition, invoicePosition).then(response => {
        this.savingInvoicePosition = false
        this.loadItems()
      }).catch(reason => {
        this.savingInvoicePosition = false
      })
    },
    openConfirmDialog (val) {
      let item = this.getItems.find(x => x.id === val)
      if (item !== null && typeof item !== 'undefined') {
        console.log('selectedInvoicePosition: ' + JSON.stringify(item))

        this.$store.dispatch(InvoicePosition.actions.setSelectedInvoicePosition, item)
      }
      this.confirmDialogState = true
    },
    cancelConfirmDialog () {
      this.$store.dispatch(InvoicePosition.actions.setSelectedInvoicePosition, null)
      this.confirmDialogState = false
    },
    openSelectedInvoicePosition (val) {
      let item = this.getItems.find(x => x.id === val)
      if (item !== null && typeof item !== 'undefined') {
        console.log('selectedInvoicePosition: ' + JSON.stringify(item))
        this.$store.dispatch(InvoicePosition.actions.setSelectedInvoicePosition, item)
        this.$store.dispatch(ManufacturerBranchOfficeSettings.actions.loadBranchOffices, item.product.manufacturer.id)
      }
      this.addDialog = true
    },
    throttledLoadItems: _.debounce(function () {
      this.loadItems()
    }, 450),
    throttledTranslate: _.debounce(function (q, target) {
      this.translate(q, target)
    }, 450),
    deletePositionDialog (item) {
      this.positionData = _.cloneDeep(item)
      this.deleteDialog = true
    },
    deletePosition () {
      if (!this.$refs.form.validate()) {
        return
      }
      this.deleteDialog = false
      this.deleteChecked = false
      this.$store.dispatch(InvoicePosition.actions.deleteInvoicePosition, this.positionData).then(response => {
        if (response !== null) {
          this.loadItems()
        }
      })
    },
    cancelDeleteDialog () {
      this.deleteDialog = false
      this.$refs.form.reset()
    },
    loadUnits () {
      this.$store.dispatch(Settings.actions.loadAllUnits)
    },
    loadVats () {
      this.$store.dispatch(VatSettings.actions.loadAllVats)
    },
    closeAddEditPositionDialog () {
      this.$store.dispatch(InvoicePosition.actions.setSelectedInvoicePosition, null)
      this.addDialog = false
    },
    positionReceivedQuantity (item) {
      let receivedQuantity = 0

      if (item.invoice.invoice_mode !== 1) {
        try {
          if (item.purchase_order_position.procurement_position.suppliers_orders_position &&
            item.purchase_order_position.procurement_position.suppliers_orders_position.supplier_order_position_received) {
            item.purchase_order_position.procurement_position.suppliers_orders_position.supplier_order_position_received.forEach(element => {
              receivedQuantity += element.quantity
            })
          }
        } catch (error) {
          console.error(error)
        }
      }

      return receivedQuantity
    },
    pickedAmount (item) {
      if (item != null) {
        if (item.picked_amount[0] && item.picked_amount[0].amount_picked) {
          return item.picked_amount[0].amount_picked
        } else {
          return 0
        }
      } else {
        return 0
      }
    }

  },
  computed: {
    getItems () {
      this.total = this.$store.getters[InvoicePosition.getters.invoicePositions].length
      return this.$store.getters[InvoicePosition.getters.invoicePositions]
    },
    selectedItem () {
      const selectedItem = this.$store.getters[Invoice.getters.getSelectedInvoice]
      return selectedItem
    },
    selectedPosition () {
      return this.$store.getters[InvoicePosition.getters.getSelectedInvoicePosition]
    },
    loading () {
      return this.$store.getters[Settings.getters.loading]
    },
    /*        getCreatingPurchaseOrderMessage () {
                      return this.$store.getters[PurchaseOrder.getters.getCreatingPurchaseOrderMessage]
                    }, */
    confirmOrderPositionDialogState () {
      return this.$store.getters[InvoicePosition.getters.getOpenDialogState]
    },
    getVats () {
      return this.$store.getters[VatSettings.getters.getAllVats]
    },
    getUnits () {
      return this.$store.getters[Settings.getters.getAllUnits]
    },
    getManufacturerBranchOffices () {
      return this.$store.getters[ManufacturerBranchOfficeSettings.getters.getBranchOffices]
    }
  },
  watch: {
    pagination: {
      handler () {
        this.loadItems()
      },
      deep: true
    },
    confirmOrderPositionDialogState: {
      handler (val) {
        if (!val) {
          this.loadItems()
        }
      },
      deep: true
    },
    search: {
      handler (val) {
        this.throttledLoadItems()
      },
      deep: true
    }
  }

}
</script>

<style scoped>

    th:focus {
        outline: none !important;
    }

</style>



// WEBPACK FOOTER //
// src/components/Invoices/InvoicePositions/InvoicePositions.vue